import { Input } from '@kognitos/lattice';
import type { DateTimeInputProps } from '../types';

/**
 * DateTime input component for date and time selection
 *
 * Renders a native datetime-local picker that handles datetimes in YYYY-MM-DDTHH:mm format.
 * Converts between browser datetime format and TypeDateTime structure.
 *
 * @param props - Component props
 * @returns JSX element containing the datetime input field
 */
export function DateTimeInput({
  name,
  value,
  onChange,
  error,
  required,
  placeholder,
  disabled,
}: DateTimeInputProps) {
  return (
    <Input
      id={name}
      name={name}
      type="datetime-local"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      aria-invalid={!!error}
      className={
        error ? 'border-destructive focus-visible:ring-destructive' : ''
      }
      disabled={disabled}
      data-testid={`input-${name}`}
    />
  );
}
